import { Injectable } from "@angular/core";
import { EMPTY, catchError, from, map, mergeMap, of, tap } from "rxjs";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as paymentsActions from "./payments.actions";
import * as invoicesActions from "../invoice-ngrx/invoices.actions";
import * as errorActions from "../../core/error/ngrx/error.actions";
import { DataService } from "src/app/supabase/services/data.service";

@Injectable()
export class PaymentEffects {
    constructor(
        private actions$: Actions,
        private dataService: DataService,
    ) {
    }

    getPayments$ = createEffect(() => this.actions$.pipe(
        ofType(paymentsActions.loadPayments),
        mergeMap(() => 
        from(this.dataService.getPayments()).pipe(
            map(payments => paymentsActions.loadPaymentsSuccess({payments})),
            catchError((error) => of(errorActions.handleError({error: "Die Zahlungen konnten nicht geladen werden.", showToast: false, exception: error})))
        ))
    ));

    addPayment$ = createEffect(() => this.actions$.pipe(
        ofType(paymentsActions.addPayment),
        mergeMap(({payment}) => 
        from(this.dataService.addPayment(payment)).pipe(
            map(payment => paymentsActions.addPaymentSuccess({payment})),
            catchError((error) => of(errorActions.handleError({error: "Die Zahlung konnte nicht erstellt werden.", exception: error})))
        ))
    ));

    addPaymentSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(paymentsActions.addPaymentSuccess),
        mergeMap(() => 
          from(this.dataService.getInvoices()).pipe(
            map(invoices => invoicesActions.loadInvoicesSuccess({invoices})),
            catchError((error) => of(errorActions.handleError({error: "Die Rechnungen konnten nicht geladen werden.", exception: error})))
          )
        )
    ));

    deletePayment$ = createEffect(() => this.actions$.pipe(
        ofType(paymentsActions.deletePayment),
        mergeMap(({payment_id}) => 
          from(this.dataService.deletePayment(payment_id)).pipe(
            map(payment => paymentsActions.deletePaymentSuccess({payment})),
            catchError((error) => of(errorActions.handleError({error: "Die Zahlung konnte nicht gelöscht werden.", exception: error})))
          )
        )
    ));

    deletePaymentSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(paymentsActions.deletePaymentSuccess),
        mergeMap(() => 
          from(this.dataService.getInvoices()).pipe(
            map(invoices => invoicesActions.loadInvoicesSuccess({invoices})),
            catchError((error) => of(errorActions.handleError({error: "Die Rechnungen konnten nicht geladen werden.", exception: error})))
          )
        )
    ));

    getPaymentBalance$ = createEffect(() => this.actions$.pipe(
        ofType(paymentsActions.getPaymentBalance),
        mergeMap(({student_id}) => 
          from(this.dataService.getPaymentBalance(student_id)).pipe(
            map(openPayments => paymentsActions.getPaymentBalanceSuccess({openPayments})),
            catchError((error) => of(errorActions.handleError({error: "Die offenen Zahlungen konnten nicht geladen werden.", showToast: false, exception: error})))
          )
        )
    ));

    createAndSendPaymentMail$ = createEffect(() => this.actions$.pipe(
      ofType(paymentsActions.createAndSendPaymentMail),
      mergeMap(({sendRequest, paymentAddRequest, file}) => 
        from(this.dataService.addPayment(paymentAddRequest)).pipe(
          tap(newPayment => {
            sendRequest = { ...sendRequest };
          }),
          mergeMap(newPayment => [
            invoicesActions.sendMail({sendRequest, payOnline: false}),
            paymentsActions.addPaymentSuccess({payment: newPayment}),
          ]),
        )
      )
    ));
}